import { BarChartOut, usageCostByUser, UsageCostByUserData, UsageQuery } from "@/api";
import { appState } from "@/app/appState";
import { barTable, ChartState } from "../table";
import { useUsageChart } from "../useUsageChart";
import { unpricedHint, usageTypeLabel, userRowLabel } from "../views";

/** LLM cost per user, split into every usage type. POST /usage/charts/cost-by-user */
export const useCostByUserChart = (query: UsageQuery | undefined): ChartState => {
    const { data, loading, failed } = useUsageChart<UsageCostByUserData, BarChartOut>(usageCostByUser, query);
    return {
        key: "cost-by-user",
        title: appState.t("usage.group.expenses"),
        loading,
        failed,
        hint: unpricedHint(data?.unpriced_tokens),
        table:
            data &&
            barTable(data, {
                rowLabel: appState.t("usage.user"),
                rowLabelFor: userRowLabel,
                columnLabelFor: usageTypeLabel,
            }),
    };
};
